import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslations } from '@vp/om-translations';
import { FlexBox, Typography } from '@vp/swan';
import { TaxAwarePriceRow } from '@vp/component-library';
import useSiteData from '../../../hooks/useSiteData';
import { currencyLocaleFormatter } from '../../../util/currencyFormatter';
import { OrderDetailsContext } from '../../contexts/OrderDetailsContext';

const FeeOption = ({ fee }) => {
  const { fractionDigits, currency } = useContext(OrderDetailsContext);
  const [feeMessages, lookUpFn] = useTranslations(['feeMessages']);
  const feeName = fee.name;
  const { hasAllCopy } = lookUpFn('feeMessages', [feeName]);
  const displayName = hasAllCopy
    ? feeMessages[feeName]
    : feeMessages.fallbackFee;

  const { locale } = useSiteData();

  return (
    <FlexBox justifyContent="space-between" my={2}>
      <Typography textColor="subtle">{displayName}</Typography>
      <Typography fontWeight="bold">
        <TaxAwarePriceRow
          fractionDigits={fractionDigits}
          listCents={fee.listCents}
          discountedCents={fee.discountedCents}
          currencyCode={currency}
          locale={currencyLocaleFormatter(locale)}
        />
      </Typography>
    </FlexBox>
  );
};

FeeOption.propTypes = {
  fee: PropTypes.object,
};

export default FeeOption;
